import React from 'react';
export var ScrollableContentContext = /*#__PURE__*/React.createContext({
  scrollContainerRef: null,
  startMovingForward: function startMovingForward() {
    return null;
  },
  stopMovingForward: function stopMovingForward() {
    return null;
  },
  startMovingBackward: function startMovingBackward() {
    return null;
  },
  stopMovingBackward: function stopMovingBackward() {
    return null;
  }
});
export var ScrollableContentContextProvider = ScrollableContentContext.Provider;